import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent {

  constructor(private router: Router) { }
  isCollapsed = false;
  userType: string | null = null;
  ngOnInit() {
    this.userType = sessionStorage.getItem("userType");
  }
  toggleMenu() {
    this.isCollapsed = !this.isCollapsed;
  }

  goToDashboard() {
    if (this.userType == 'Employee')
      this.router.navigate(['/leave-request']);
    else
      this.router.navigate(['/dashboard']);
  }

  goToChangePassword() {
    this.router.navigate(['/reset-password']);
  }

  goToOutstandingReport() {
    this.router.navigate(['/outstanding-report']);
  }

  goToApplyLeave() {
    this.router.navigate(['/apply-leave']);
  }

  goToLeaveRequest() {
    this.router.navigate(['/leave-request']);
  }

  goToSalaryAdvanceRequest() {
    this.router.navigate(['/apply-salary-advance']);
  }

  goToAdvanceSalaryStatus() {
    this.router.navigate(['/salary-advance-status']);
  }

  goToApplyLoan() {
    this.router.navigate(['/apply-loan']);
  }

  goToLoanRequestStatus() {
    this.router.navigate(['/loan-request-status']);
  }

  logout() {
    // Clear session/local storage if needed
    localStorage.clear();
    sessionStorage.removeItem('userToken');
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
}
